import { render } from "./ImportProgram.vue?vue&type=template&id=2fada7f8&ts=true"
import script from "./ImportProgram.vue?vue&type=script&lang=ts"
export * from "./ImportProgram.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/david/Documents/repos/fancypools-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__